import { combineReducers } from '@reduxjs/toolkit';
import {
    auth,
    layout,
    reconnecting,
    purchases,
    screen,
    stores,
    user,
    announcer,
    settings,
} from './slices';

const rootReducer = combineReducers({
    auth: auth.authReducer,
    layout: layout.layoutReducer,
    reconnecting: reconnecting.reconnectingReducer,
    purchases: purchases.purchasesReducer,
    stores: stores.storesReducer,
    user: user.userReducer,
    screen: screen.screenReducer,
    announcer: announcer.announcerReducer,
    settings: settings.settingsReducer,
});

export * from './slices/auth';
export * from './slices/layout';
export * from './slices/reconnecting';
export * from './slices/purchases';
export * from './slices/stores';
export * from './slices/user';
export * from './slices/screen';

export default rootReducer;
